import 'react-native-random-uuid'
import 'expo-router/entry'

import { Platform } from 'react-native'
import { HIDE_ERRORS, IS_PROD, PB_SERVER_ADDR } from './lib/config'
import { initSentry, Sentry } from './lib/errors'
import { log } from './lib/logger'

initSentry()

Sentry.addBreadcrumb({
    category: 'boot',
    level: 'info',
    message: 'App config at boot',
    data: {
        IS_PROD,
        PB_SERVER_ADDR,
        HIDE_ERRORS,
    },
})

if (Platform.OS !== 'web') {
    const { bootstrapBackgroundGeolocation, registerBackgroundSync } = require('./lib/geo-tracking')
    const { sendAuthFailureNotification } = require('./lib/notifications')
    const BackgroundGeolocation = require('react-native-background-geolocation').default

    const BGHeadlessTask = async (event: {
        name: string
        params: { success?: boolean; error?: string; status?: number }
    }) => {
        const { name, params } = event
        log.info(`[BGHeadlessTask] event: ${name}`, params)

        switch (name) {
            case 'authorization':
                if (!params.success) {
                    log.warn('[BGHeadlessTask] Authorization failed:', params.error)
                    await sendAuthFailureNotification()
                }
                break

            case 'http':
                if (params.status === 401) {
                    log.warn('[BGHeadlessTask] HTTP 401 received')
                    await sendAuthFailureNotification()
                }
                break

            default:
                break
        }
    }

    // Per docs: ready() must be called on every launch (releases the SDK's
    // buffered event queue). The bootstrap does NOT call start/stop — the
    // useLocationTracking hook drives that via applyTrackingMode once user
    // prefs are available.
    bootstrapBackgroundGeolocation().then(() => {
        registerBackgroundSync()
        BackgroundGeolocation.registerHeadlessTask(BGHeadlessTask)
    })
}
